document.addEventListener('DOMContentLoaded', function () {

    let isStickyVisible = false; // Track visibility of the sticky ATC button

    // Function to toggle visibility of sticky ATC
    function toggleStickyATC() {

        const stickyATC = document.querySelector('.sticky-atc');
        const chatIcon = document.getElementById('gorgias-chat-container');
        const save15PercentText = document.getElementById('attentive_overlay');
        const atcButton = document.querySelector('.product-single__form');
        if (window.innerWidth <= 500) { // Check if the window width is 500px or less 
            const isScrolledPast = atcButton && atcButton.getBoundingClientRect().bottom < 0; // Check if ATC button is scrolled past
            
            if (isScrolledPast) { // Only show if not already visible
                // Hide chat icon and save 15% text
                if (chatIcon) {
                    chatIcon.style.display = 'none'; // Hide chat icon
                }
                if (save15PercentText) {
                    save15PercentText.style.display = 'none'; // Hide save 15% text
                }
                if(!isStickyVisible){ 
                    // Show the sticky ATC button
                    stickyATC.classList.add('show');
                    stickyATC.style.visibility = 'visible';
                    isStickyVisible = true; // Update visibility state
                }   
            } else if (!isScrolledPast && isStickyVisible) { // Only hide if currently visible 
                
                // Hide the sticky ATC button
                stickyATC.classList.remove('show');

                // Delay hiding visibility to allow transition to complete
                setTimeout(() => {
                    stickyATC.style.visibility = 'hidden'; // Hide it after transition
                }, 400); // Match this timeout with the CSS transition duration

                // Show chat icon and save 15% text
                if (chatIcon) {
                    chatIcon.style.display = 'block'; // Show chat icon
                }
                if (save15PercentText) {
                    save15PercentText.style.display = 'block'; // Show save 15% text
                }
                isStickyVisible = false; // Update visibility state
            }
        } else {
            // If the window width is greater than 500px, ensure everything is visible 
            if (isStickyVisible) { 
                stickyATC.classList.remove('show'); // Hide the ATC button
                stickyATC.style.visibility = 'hidden'; // Hide it immediately for larger screens
                isStickyVisible = false; // Reset visibility state
            }

            // Always show the chat icon and save 15% text on larger screens
            if (chatIcon) {
                chatIcon.style.display = 'block'; // Show chat icon
            }
            if (save15PercentText) {
                save15PercentText.style.display = 'block'; // Show save 15% text
            }
        }
    }

    // Listen for scroll events
    window.addEventListener('scroll', toggleStickyATC);

    // Listen for resize events to adjust visibility
    window.addEventListener('resize', toggleStickyATC);

    // Initial call to set visibility based on current window size and scroll position
    toggleStickyATC();
});
